// React
import { useContext, useEffect, useRef, useState } from "react";

// Context
import { mainContext } from "../../context/mainContext";

// Assets
import '../../assets/styles/languageSelector.css'
import { MdLanguage } from "react-icons/md";

const languages = [
  { code: "hu", label: "Magyar" },
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" }, // Add more if needed
];

const LanguageSelector = () => {
  const { language, setLanguage } = useContext(mainContext);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const isDesktop = () => window.matchMedia("(min-width: 1400px)").matches;

  return (
    <div
      ref={dropdownRef}
      className="dropdownContainer"
      /* open / close *only* when (mouse pointer) AND (desktop width) */
      onPointerEnter={(e) => {
        if (e.pointerType === "mouse" && isDesktop()) setIsOpen(true);
      }}
      onPointerLeave={(e) => {
        if (e.pointerType === "mouse" && isDesktop()) setIsOpen(false);
      }}
    >
      {/* globe icon – click / tap still toggles everywhere */}
      <MdLanguage
        className="languageIcon"
        onClick={() => setIsOpen((o) => !o)}
        aria-expanded={isOpen}
        role="button"
        tabIndex={0}
      />

      <div className={`languageDropdown ${isOpen ? "isOpen" : ""}`}>
        {languages.map(({ code, label }) => (
          <div
            key={code}
            className={`dropdownItem ${language === code ? "activeLanguage" : ""
              }`}
            onClick={() => {
              if (code !== language) setLanguage(code);
              setIsOpen(false);
            }}
          >
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}

export default LanguageSelector;
